import { useEffect, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { AuthenticationKind } from 'constants/authentication'
import useKeyboardState from 'hooks/useKeyboardState'
import useSessionContext from 'hooks/useSessionContext'
import { convertPxToMuiSpacing } from 'redesign/themes/main/utils'
import { ZERO } from 'shared/constants'
import { isNative, isNativeNoOverride } from 'utils/platform'
import { StatusBar, Style } from '@capacitor/status-bar'
import type { PageProps } from './types'

const usePage = ({
  footer,
  extraBottomMargin = ZERO,
  hideNativeNavigation,
  showHamburgerHeader = !isNative(),
}: PageProps) => {
  const { isOpen, keyboardHeight } = useKeyboardState()
  const extraBotMargin = (isOpen ? convertPxToMuiSpacing(keyboardHeight) : ZERO) + extraBottomMargin
  const theme = useTheme()
  const { auth } = useSessionContext()
  const [displayMenu, setDisplayMenu] = useState(false)
  const showSidePanel = () => setDisplayMenu(true)
  const hideSidePanel = () => setDisplayMenu(false)
  const toggleDrawer = () => setDisplayMenu(!displayMenu)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isSmallNativeScreen = isNativeNoOverride() && isSmallScreen

  const hasNavbar = auth === AuthenticationKind.AUTHENTICATED && !hideNativeNavigation
  const displayHamburgerHeader = auth === AuthenticationKind.AUTHENTICATED && showHamburgerHeader
  const removePaddingBottom = hasNavbar || !footer

  useEffect(() => {
    if (isSmallNativeScreen) {
      if (displayMenu) {
        StatusBar.setStyle({ style: Style.Dark })
      } else {
        StatusBar.setStyle({ style: Style.Light })
      }
    }
  }, [displayMenu, isSmallNativeScreen])

  return {
    auth,
    displayHamburgerHeader,
    displayMenu,
    extraBotMargin,
    hideSidePanel,
    showSidePanel,
    toggleDrawer,
    isSmallNativeScreen,
    removePaddingBottom,
    theme,
    isOpen,
    hasNavbar,
  }
}

export default usePage
